module.exports = __webpack_public_path__ + "img/spa.ae9b1b92.svg";